import React, { useEffect, useState, useRef } from "react";
import { MdOutlineTranslate } from "react-icons/md";
import { motion } from "framer-motion";
import i18next from "i18next";
import { useLanguage } from "context/LanguageContext";

const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "hi", label: "Hindi" },
  { code: "sw", label: "Swahili" },
  { code: "mr", label: "Marathi" },
];

const LanguageSelector = () => {
  const dropdownRef = useRef(null);
  const { lang, setLang } = useLanguage();
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const toggleLanguageDropdown = () => {
    setLanguageDropdownOpen(!languageDropdownOpen);
  };

  const handleLanguageChange = (languageCode) => {
    setLang(languageCode);
    i18next.changeLanguage(languageCode);
    localStorage.setItem("selectedLanguage", languageCode);
    setLanguageDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setLanguageDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLang(localStorage.getItem("selectedLanguage") || "en");
    i18next.changeLanguage(localStorage.getItem("selectedLanguage") || "en");
  }, []);

  return (
    <div className="relative cursor-pointer" ref={dropdownRef}>
      <MdOutlineTranslate
        onClick={toggleLanguageDropdown}
        className={`text-black text-[30px] 2xl:text-[40px]`}
      />
      {languageDropdownOpen && (
        <motion.ul
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="absolute right-0 mt-2 w-40 bg-white shadow-md rounded-lg z-50"
        >
          {languages.map((lan) => (
            <li
              key={lan.code}
              className={`p-2 2xl:text-[18px] cursor-pointer hover:bg-gray-200 ${lang === lan.code ? "text-darkOrange font-semibold" : ""
                } text-center`}
              onClick={() => handleLanguageChange(lan.code)}
            >
              {lan.label}
            </li>
          ))}
        </motion.ul>
      )}
    </div>
  );
};

export default LanguageSelector;
